<div class="links" *ngIf="displaySelectAll">
	<a class="selectLink" (click)="checkAll()" href="javascript:void(0)">{{ 'UI.Global.SelectAll' | translate }}</a>
	<a class="selectLink" (click)="uncheckAll()" href="javascript:void(0)">{{ 'UI.Global.UnselectAll' | translate }}</a>
</div>
<div [ngClass]="inline ? 'inline' : ''">
	<div *ngFor="let item of items.items">
		<a (click)="detailAsked(item)" style="float:right; color: black;" href="javascript:void(0)" *ngIf="detailButton">
			<i class="material-icons">list</i>
		</a>
		<label>
			<mat-checkbox
				*ngIf="canSelect"
				[disabled]="disabled"
				[value]="item[value]"
				(change)="checkChanged($event)"
				[checked]="position(item[value]) > -1"
				class="checkbox"
			>
				{{ item[label] }}
			</mat-checkbox>
			<div *ngIf="!canSelect">
				{{ item[label] }}
			</div>
		</label>
	</div>
</div>
